import { render, staticRenderFns } from "./BoletoPayment.vue?vue&type=template&id=34b66cad&scoped=true"
import script from "./BoletoPayment.vue?vue&type=script&lang=js"
export * from "./BoletoPayment.vue?vue&type=script&lang=js"
import style0 from "./BoletoPayment.vue?vue&type=style&index=0&id=34b66cad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b66cad",
  null
  
)

export default component.exports